var _circle, _circle2, _circle3, _path, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconWechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28729",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.54,
    height: 29.541,
    viewBox: "0 0 29.54 29.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    cx: 1.107,
    cy: 1.107,
    r: 1.107,
    transform: "translate(13.168 9.513)",
    fill: "#2dc100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(15.478 14.239)",
    fill: "#2dc100"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 1.107,
    cy: 1.107,
    r: 1.107,
    transform: "translate(8.457 9.513)",
    fill: "#2dc100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    d: "M28.978,14.166a14.77,14.77,0,1,0,14.77,14.77A14.77,14.77,0,0,0,28.978,14.166ZM23.869,32.361l-2.556,1.152.533-2.036A5.7,5.7,0,0,1,18.971,26.7c0-3.3,3.227-5.973,7.208-5.973,3.338,0,6.145,1.88,6.965,4.432-.167-.01-.334-.016-.5-.016-3.96,0-7.183,2.741-7.183,6.11a5.244,5.244,0,0,0,.193,1.4A8.578,8.578,0,0,1,23.869,32.361Zm12.813,2.861.464,1.921-2.11-1.071a7.371,7.371,0,0,1-2.434.407c-3.455,0-6.255-2.321-6.255-5.184s2.8-5.183,6.255-5.183,6.256,2.32,6.256,5.183A4.861,4.861,0,0,1,36.682,35.222Z",
    transform: "translate(-14.208 -14.166)",
    fill: "#2dc100"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 1.053,
    cy: 1.053,
    r: 1.053,
    transform: "translate(19.543 14.239)",
    fill: "#2dc100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconWechat);
export default __webpack_public_path__ + "static/media/social-icon-wechat.a00451dc36ff0a625b18edb52a93351f.svg";
export { ForwardRef as ReactComponent };